import { useState, useEffect } from 'react';
import axios from 'axios';

export const useContentData = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({
    products: [],
    hero: null,
    features: null,
    gallery: null,
    settings: null,
    footer: null,
    topnav: null,
    seo: null,
  });
  const [error, setError] = useState(null);

  const API_URL = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    const fetchAllContent = async () => {
      try {
        setLoading(true);
        const [productsRes, heroRes, featuresRes, galleryRes, settingsRes, footerRes, topnavRes, seoRes] = await Promise.all([
          axios.get(`${API_URL}/api/products`),
          axios.get(`${API_URL}/api/hero`),
          axios.get(`${API_URL}/api/features`),
          axios.get(`${API_URL}/api/gallery`),
          axios.get(`${API_URL}/api/settings`),
          axios.get(`${API_URL}/api/footer`),
          axios.get(`${API_URL}/api/topnav`),
          axios.get(`${API_URL}/api/seo`).catch(() => ({ data: null })),
        ]);

        setData({
          products: productsRes.data,
          hero: heroRes.data,
          features: featuresRes.data,
          gallery: galleryRes.data,
          settings: settingsRes.data,
          footer: footerRes.data,
          topnav: topnavRes.data,
          seo: seoRes.data,
        });
        setError(null);
      } catch (err) {
        console.error('Error fetching content:', err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchAllContent();
  }, [API_URL]);

  return { data, loading, error };
};
